<template>
	<div class="solution-banner" :style="{backgroundImage:'url('+dataimgs[0].src1+')'}">
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
				<div class="center">
					<div class="banner-overlay1">
						<h1>{{dataimgs[0].title}}</h1>
						<p v-for="c in dataimgs[0].content" :key='c'>{{c}}</p>
						<div class="try-btn-area">
							<a :href="dataimgs[0].url" target="_blank">
								<el-button type="primary" class="hidden-md-and-down">{{dataimgs[0].btn}}</el-button>
							</a>
							<a :href="dataimgs[0].url" target="_blank">
								<el-button type="primary" size="small" class="hidden-lg-and-up">{{dataimgs[0].btn}}</el-button>
							</a>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'SolutionBanner',
		props: ['dataimgs'],
		data() {
			return {
				imgHeight: ''
			}
		},
		methods: {
			imgLoad() {
				this.$nextTick(() => {
					this.imgHeight = this.$refs.imgHeight[0].height;
				})
			}
		},
		mounted() {
			this.imgLoad();
			window.addEventListener('resize', () => {
				this.imgHeight = this.$refs.imgHeight[0].height;
				this.imgLoad();
			}, false)
		}
	}
</script>

<style>
	.solution-banner {
		height: 540px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.solution-banner .center {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.solution-banner .banner-overlay1 {
		width: 570px;
		padding: 180px 30px 0;
		color: #FFFFFF;
		text-align: left;
	}

	.solution-banner .banner-overlay1 .title {
		-webkit-transform: translateY(0px) !important;
		transform: translateY(0px) !important;
		opacity: 1 !important;
		font-size: 30px;
		font-family: MFYueHei_Noncommercial-Light;
		color: rgba(255, 255, 255, 1);
		/* line-height: 63px; */
		font-weight: lighter;
	}

	.banner-overlay1 h1 {
		color: #FFFFFF;
		font-size: 30px;
		transform: translateY(0px);
		line-height: 64px;
		transition: all 0.6s;
		margin-bottom: 15px;
		width: 100%;
	}

	.banner-overlay1 p {
		color: #FFFFFF;
		font-size: 16px;
		transform: translateY(0px);
		line-height: 30px;
		transition: all 0.6s;
		width: 100%;
	}

	.banner-overlay1 .try-btn-area {
		color: #FFFFFF;
		width: initial;
		text-align: left;
		font-size: 48px;
		line-height: 48px;
		margin-top: 30px;
	}

	@media(max-width:992px) {
		.solution-banner {
			height: 248px;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.solution-banner .banner-overlay1 {
			padding: 80px 30px 0;
			color: #FFFFFF;
			text-align: left;
		}

		.solution-banner .banner-overlay1 h1 {
			color: #FFFFFF;
			font-size: 18px;
			transform: translateY(0px);
			line-height: 24px;
			transition: all 0.6s;
			margin-bottom: 5px;
		}

		.solution-banner .banner-overlay1 p {
			color: rgba(255, 255, 255, .5);
			font-size: 14px;
			transform: translateY(0px);
			line-height: 14px;
			transition: all 0.6s;
		}

		.solution-banner .banner-overlay1 .try-btn-area {
			color: #FFFFFF;
			width: initial;
			text-align: left;
			font-size: 48px;
			line-height: 48px;
			margin-top: 10px;
		}

		.solution-banner .banner-overlay1 .try-btn-area .el-button {
			type: small;
			margin-left: 0;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SolutionBanner.vue